import React, { memo } from 'react'

import { useWatch } from 'react-hook-form'

import { PaymentMethods } from 'Types'

import SquareApplePay from 'Components/Square/ApplePay'
import SquareGooglePay from 'Components/Square/GooglePay'

import { usePayment } from '../../PaymentArea/Provider'

interface Props {
  disabled?: boolean
}
const SquareBtn = ({ disabled }: Props) => {
  const { gateway } = usePayment()
  const { applePay, googlePay, field } = gateway
  const paymentMethod = useWatch({ name: `${field}.paymentMethod` })

  return (
    <>
      {applePay ? (
        <div hidden={paymentMethod !== PaymentMethods.APPLE_PAY || disabled}>
          <SquareApplePay />
        </div>
      ) : null}
      {googlePay ? (
        <div hidden={paymentMethod !== PaymentMethods.GOOGLE_PAY || disabled}>
          <SquareGooglePay buttonType="order" />
        </div>
      ) : null}
    </>
  )
}

export default memo(SquareBtn)
